import axios, { AxiosResponse } from 'axios';
import { CommonRootState } from '../combineReducers';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';
import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

const { Equals, NotEquals } = OdataComparator;

enum ReportStatus {
  Submitted = 'Submitted'
}

const { Submitted } = ReportStatus;

const fetchReportingNotificationsCountSuccess = (flexTrackCount: number, operationsCount: number) =>
  ({
    type: 'FETCH_REPORTING_NOTIFICATIONS_COUNT_SUCCESS',
    flexTrackCount,
    operationsCount
  } as const);

const getParams = (organizationId: string) =>
  new QueryBuilder()
    .top(0)
    .filter(f => f.filterBy('contractorId', Equals, organizationId).filterBy('reportStatus', NotEquals, Submitted))
    .toQueryParam();

export const fetchReportingNotificationsCount = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    const odataParams = getParams(organizationId);
    const params = { ...odataParams, removeUnreleasedClients: true };

    const [flexTrackResponse, operationsResponse] = (await axios.all([
      axios.get<{ '@odata.count': number }>('/api/v3.01/regionalContractorPeriods', {
        params
      }),
      axios.get<{ '@odata.count': number }>('/api/v3.01/operationalContractorPeriods', {
        params
      })
    ])) as [AxiosResponse<{ '@odata.count': number }>, AxiosResponse<{ '@odata.count': number }>];

    dispatch(
      fetchReportingNotificationsCountSuccess(
        flexTrackResponse.data['@odata.count'],
        operationsResponse.data['@odata.count']
      )
    );
  } catch (error) {
    sendError(error);
  }
};

export type Actions = ReturnType<typeof fetchReportingNotificationsCountSuccess>;
